if (typeof JW === 'undefined') JW = {};
JW.Mapform = function ($, mf)
{
    var _pri = {};
    var publ = {};

    _pri.cname = 'MAPFORM';
    _pri.opts = {
        dbg_lvl: 1,
        afs: ['street', 'street_no', 'zip', 'city', 'cc']   // address fields
    };

    _pri.uid = '';
    _pri.inited = false;
    _pri.page = null;

    _pri.$form = $(mf);
    _pri.afs = {};                      // addr form fields
    _pri.$latf = null;
    _pri.$lngf = null;

    _pri.mapw = null;

    _pri.extend = function()
    {
        JW.ExtCommon(jQuery, publ, _pri);
    };

    _pri.init = function()
    {
        _pri.dbg('******** init()');

        if (_pri.inited)
        {
            _pri.dbg('!!! already inited!');
            return;
        }

        if (_pri.$form.length == 0)
        {
            _pri.dbg('    no form - exit');
            _pri.$form = null;
            return;
        }

        _pri.inited = true;
        _pri.page = JW.Page;
        _pri.uid = JW.Page.getUId();

        var $mws = _pri.$form.find('.mapwidget');

        if ($mws.length > 0)
        {
            _pri.mapw = JW.Mapwidget(jQuery, $mws[0], {form_id: _pri.uid});
        }
        else
        {
            _pri.dbg('    no map widget, trying without ...');
        }

        _pri.initEvents();
        _pri.initForm();
    };

    _pri.initEvents = function()
    {
        _pri.page.on('geoc:get_ll_to_address_done', function(e, o) {
            _pri.dbg('on geoc:get_ll_to_address_done', o);

            if (!_pri.$form)
            {
                return;
            }

            if (o.addr.form_id == _pri.uid)
            {
                _pri.$latf.val(o.ll.lat);
                _pri.$lngf.val(o.ll.lng);
            }
        });

        _pri.page.on('geoc:get_address_to_ll_done', function(e, o) {
            _pri.dbg('on geoc:get_address_to_ll_done', o);

            if (!_pri.$form || !_pri.mapw)
            {
                return;
            }

            // _pri.dbg('    >>> 1');

            if (o.ll.toString() != _pri.mapw.getRid())
            {
                return;
            }

            // _pri.dbg('    >>> 2');

            var str = o.addr.place_name;
            var parts = str.split(',');

            if (parts.length == 4)
            {
                // _pri.dbg('    >>> 3 > parts.length == 4');
                var rx = /^(.+?) (\d+[^ ]*)$/;
                var mtc = rx.exec(parts[0]);
                // _pri.dbg(mtc);
                if (mtc && mtc.length == 3)
                {
                    _pri.afs.street.val(mtc[1]);
                    _pri.afs.street_no.val(mtc[2]);
                }

                _pri.afs.city.val(parts[1].trim());

                rx = /^.+? (\d+)$/;
                mtc = rx.exec(parts[2]);
                if (mtc.length == 2)
                {
                    _pri.afs.zip.val(mtc[1]);
                }
            }
            // Beim Stegen 5, 21439 Marxen, Germany
            else if (parts.length == 3)
            {
                // _pri.dbg('    >>> 3 > parts.length == 2');
                var rx = /^(.+?)(?: (\d+[^ ]*))?$/;
                var mtc = rx.exec(parts[0]);
                // _pri.dbg('    mtc: ', mtc);
                if (mtc && mtc.length > 1)
                {
                    if (mtc.length == 3 && typeof mtc[2] !== 'undefined')
                    {
                        _pri.afs.street.val(mtc[1]);
                        _pri.afs.street_no.val(mtc[2]);
                    }
                    else if (mtc.length == 2 || mtc.length == 3 && typeof mtc[2] === 'undefined')
                    {
                        _pri.afs.street.val(mtc[1]);
                        _pri.afs.street_no.val('');
                    }
                }

                rx = /^(\d{2,5}[^ ]*) (.+)$/;
                mtc = rx.exec(parts[1].trim());
                // _pri.dbg(mtc);
                if (mtc && mtc.length == 3)
                {
                    _pri.afs.zip.val(mtc[1]);
                    _pri.afs.city.val(mtc[2].trim());
                }
            }

            _pri.$latf.val(o.ll.lat);
            _pri.$lngf.val(o.ll.lng);
        });
    };

    _pri.initForm = function()
    {
        var len = _pri.opts.afs.length;
        var i, $inp;
        var afs_cnt = 0;

        for (i = 0; i < len; ++i)
        {
            $inp = _pri.$form.find('input[name="' + _pri.opts.afs[i] + '"]');
            if ($inp.length > 0)
            {
                $inp.on('change', _pri.onAfsChange);
                _pri.afs[_pri.opts.afs[i]] = $inp;
                ++afs_cnt;
            }
            else if (_pri.opts.afs[i] != 'cc') // cc is optional for now ...
            {
                _pri.dbg('!!! missing field: ', _pri.opts.afs[i]);
            }
        }

        if (afs_cnt < 4)
        {
            _pri.dbg('!!! addr fields count < 4! afs_cnt:', afs_cnt);
        }

        _pri.$latf = _pri.$form.find('input[name="lat"]');
        _pri.$lngf = _pri.$form.find('input[name="lng"]');


        //_pri.resolveAddr();
        _pri.onAfsChange();
    };

    _pri.resolveAddr = function()
    {
        var addr = {};
        var len = _pri.opts.afs.length;
        var i;
        var empt = false;

        for (i = 0; i < len; ++i)
        {
            if (_pri.afs.hasOwnProperty(_pri.opts.afs[i]))
            {
                addr[_pri.opts.afs[i]] = _pri.afs[_pri.opts.afs[i]].val();
            }
        }

        addr.form_id = _pri.uid;
        //_pri.dbg('addr', addr);
        JW.GeoC.getLLToAddress(addr);
    };

    _pri.onAfsChange = function(e)
    {
        _pri.dbg('******** onAfsChange()');

        _pri.$latf.val('');
        _pri.$lngf.val('');

        if (_pri.mapw)
        {
            _pri.mapw.hideMarker();
        }

        var p;
        var addr = {};
        var empt = false;

        for (p in _pri.afs)
        {
            if (_pri.afs.hasOwnProperty(p))
            {
                if (_pri.afs[p].val() == '')
                {
                    empt = true;
                    break;
                }
            }
        }

        if (!empt)
        {
            _pri.dbg('         changegd - calling resolveAddr()');
            _pri.resolveAddr();
        }
    };


    _pri.extend();
    _pri.init();
    // expose public methods
    return publ;
};
